import { render, staticRenderFns } from "./TrTitleBar.vue?vue&type=template&id=1b885379&"
import script from "./TrTitleBar.vue?vue&type=script&lang=js&"
export * from "./TrTitleBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports